import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import EditorSidebar from './EditorSidebar';

const EditorLayout = () => {
  const [language, setLanguage] = useState("ne");

  return (
    <div className="flex min-h-screen bg-gray-50">
      <EditorSidebar language={language} />

      <main className="flex-1 min-w-0 overflow-x-hidden">
        <div className="sticky top-0 z-30 flex items-center justify-between border-b border-gray-100 bg-white/80 px-6 py-3.5 backdrop-blur-md">
          <div className="flex items-center gap-2 text-sm text-gray-400 font-bold lg:pl-0 pl-12">
            <span className="text-primary font-extrabold">
              {language === 'ne' ? 'सम्पादक' : 'Editor'}
            </span>
          </div>

          <div className="flex items-center gap-3">
            {/* Language toggle */}
            <button
              onClick={() => setLanguage(l => l === "ne" ? "en" : "ne")}
              className="flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-3 py-1.5 text-xs font-extrabold text-gray-600 transition-all hover:border-primary hover:text-primary"
            >
              <span>{language === "ne" ? "EN" : "नेपाली"}</span>
            </button>

            <span className="hidden sm:inline-block rounded-full bg-primary-50 px-3 py-1 text-xs font-extrabold text-primary border border-primary-100">
              {language === 'ne' ? 'सम्पादक पहुँच' : 'Editor Access'}
            </span>
          </div>
        </div>

        <div className="p-6 lg:p-8">
          <Outlet context={{ language }} />
        </div>
      </main>
    </div>
  );
};

export default EditorLayout;